/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ActionDataStructure } from './ActionDataStructure';
import type { NaturalLanguageStringStructure } from './NaturalLanguageStringStructure';

export type PublishToTvActionStructure = {
  actionStatus?: PublishToTvActionStructure.actionStatus;
  description?: NaturalLanguageStringStructure;
  actionData?: Array<ActionDataStructure>;
  ceefax?: boolean;
  teletext?: boolean;
};

export namespace PublishToTvActionStructure {
  export enum actionStatus {
    OPEN = 'OPEN',
    PUBLISHED = 'PUBLISHED',
    CLOSED = 'CLOSED',
  }
}
